<template>
  <div ref="fristhome">
    <!--        <el-breadcrumb separator-class="el-icon-arrow-right">-->
    <!--            <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
    <!--            <el-breadcrumb-item>单车多险种</el-breadcrumb-item>-->
    <!--        </el-breadcrumb>-->
    <el-card class="box-card">
      <el-form :inline="true" ref="searchForRef" autocomplete="on" size="mini">
        <dl
          style="display:flex;flex-direction: row;align-items: center;justify-content:flex-start;"
        >
          <dt style="background-color: #e1f3d8;border-radius: 5px;width: 30%;">
            <h5 style="color: #666;padding:20px 0 0 20px;">其他渠道保险～建档</h5>
            <p style="display:flex;flex-direction: row;align-items: center;padding: 10px;">
              <el-form-item>
                <el-button type="primary" @click.native="addData">单车多险种</el-button>
              </el-form-item>
              <!--                            <el-form-item>-->
              <!--                                <el-button   @click.native="addByProduct">单险种多车</el-button>-->
              <!--                            </el-form-item>-->
            </p>
          </dt>
          <dd style="background-color: #e6f1fe;border-radius: 5px;margin-left: 50px;width: 30%;">
            <h5 style="color: #666;padding:20px 0 0 20px;">系统内保险</h5>
            <p style="display:flex;flex-direction: row;align-items: center;padding: 10px;">
              <!--                            <el-form-item>-->
              <!--                                <el-button    @click.native="addSysCar">系统单车多险种</el-button>-->
              <!--                            </el-form-item>-->
              <el-form-item>
                <el-button @click.native="addSysProduct">系统单险种多车</el-button>
              </el-form-item>
            </p>
          </dd>
        </dl>
      </el-form>

      <header style="color: #3a8ee6;font-weight: bold;padding: 10px 0">
        <span>提示：</span>
        <span>一车多险种～建档</span>
      </header>

      <el-tabs v-model="activeName" @tab-click="handleTabClick" class="custom-tabs">
        <el-tab-pane label="手动保单建档" name="first">
          <other-add-insurance ref="refOtherAddInsurance"></other-add-insurance>
        </el-tab-pane>
        <el-tab-pane label="自动导入保单" name="second">
          <excel-import></excel-import>
          <span slot="label"> 自动导入保单<i class="el-icon-right"></i></span>
        </el-tab-pane>
        <el-tab-pane label="智能辅助建档" name="three">
          <OtherAddInsurance1 ref="refOtherAddInsurance1"></OtherAddInsurance1>
        </el-tab-pane>
        <!-- <el-tab-pane label="手动导入保单" name="four">
                        <ExcelImport1></ExcelImport1>
        </el-tab-pane>-->
        <!-- <el-tab-pane label="修正文档" name="six">
                      <amendment ref="refamendment"></amendment>
        </el-tab-pane>-->
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import moment from "moment";
import Watermark from "../../utils/waterMark";
import ExcelImport from "../common/excelImport.vue";
import ExcelImport1 from "../common/excelImportOld.vue";
import OtherAddInsurance from "./otherAddInsurance.vue";
import OtherAddInsurance1 from "./otherAddInsurance1.vue";
import amendment from "./amendment.vue";
export default {
  name: "insuranceAdd",
  components: {
    OtherAddInsurance,
    OtherAddInsurance1,
    ExcelImport,
    amendment,
    ExcelImport1,
  },

  mounted() {
    let str =
      sessionStorage.getItem("userName") +
      " " +
      moment().format("yyyy-MM-DD HH:mm:ss");
    this.$nextTick(() => {
      //要加载完才能获取$refs
      Watermark.set(str, this.$refs.fristhome);
    });
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    handleTabClick(tab) {
      // 这里编写你的点击事件处理逻辑
      if (tab.name == "three") {
        this.$refs.refOtherAddInsurance1.getList();
      }
      const index = tab.index;
      if (index == 1) {
        this.setActiveBarTransform(224);
      } else if (index == 2) {
        this.setActiveBarTransform(362);
      }
    },
    setActiveBarTransform(translateX) {
      this.$nextTick(() => {
        const activeBar = this.$el.querySelector(".el-tabs__active-bar");
        activeBar.style.transform = `translateX(${translateX}px)`;
      });

    },
    // 新增
    addData() {
      this.$router.push("/insuranceAdd");
    },
    addByProduct() {
      this.$router.push("/insuranceAddByProduct");
    },
    addSysProduct() {
      this.$router.push("/insuranceSysProduct");
    },
    addSysCar() {
      this.$router.push("/insuranceSysCar");
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .custom-tabs .el-tabs__item:nth-child(2) {
  margin-right: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/insurance/insuranceAdd.vue